import { User } from './User';
import { Company } from './Company';

export class UserCompany {
    public userCompanyId: number;
    public userId: number;
    public companyId: number;
    public user: User;
    public company: Company;
}